export default "__VITE_ASSET__DYj6utbc__"